module.exports = __webpack_public_path__ + "static/media/projects.fivethirtyeight.com_general-forecast_plot.fb4288b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/projects.fivethirtyeight.com_general-forecast_plot.png
// module id = 419
// module chunks = 0